
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18582_1bhk8_93",
  "child": "awsui_child_18582_1bhk8_97",
  "horizontal": "awsui_horizontal_18582_1bhk8_108",
  "horizontal-xxxs": "awsui_horizontal-xxxs_18582_1bhk8_112",
  "horizontal-xxs": "awsui_horizontal-xxs_18582_1bhk8_115",
  "horizontal-xs": "awsui_horizontal-xs_18582_1bhk8_118",
  "horizontal-s": "awsui_horizontal-s_18582_1bhk8_121",
  "horizontal-m": "awsui_horizontal-m_18582_1bhk8_124",
  "horizontal-l": "awsui_horizontal-l_18582_1bhk8_127",
  "horizontal-xl": "awsui_horizontal-xl_18582_1bhk8_130",
  "horizontal-xxl": "awsui_horizontal-xxl_18582_1bhk8_133",
  "vertical": "awsui_vertical_18582_1bhk8_140",
  "vertical-xxxs": "awsui_vertical-xxxs_18582_1bhk8_143",
  "vertical-xxs": "awsui_vertical-xxs_18582_1bhk8_146",
  "vertical-xs": "awsui_vertical-xs_18582_1bhk8_149",
  "vertical-s": "awsui_vertical-s_18582_1bhk8_152",
  "vertical-m": "awsui_vertical-m_18582_1bhk8_155",
  "vertical-l": "awsui_vertical-l_18582_1bhk8_158",
  "vertical-xl": "awsui_vertical-xl_18582_1bhk8_161",
  "vertical-xxl": "awsui_vertical-xxl_18582_1bhk8_164",
  "align-center": "awsui_align-center_18582_1bhk8_168",
  "align-start": "awsui_align-start_18582_1bhk8_172",
  "align-end": "awsui_align-end_18582_1bhk8_176"
};
  